import React from "react";
import { makeStyles } from "@mui/styles";
import {
  Grid,
  Typography,
  DialogContent,
  Dialog,
  Button,
  DialogActions,
} from "@mui/material";
import { PrimaryDialogTitle } from "Components/Common/Dialog/DialogComponents";
import moment from "moment";
import { InstallmentDispensingDetail } from "utils/data";
import { capitalizeFirstLetter, getEllipsisName } from "utils/generalUtils";
const useStyle = makeStyles((theme) => ({
  rsPatientDetails: {
    display: "flex",
  },
}));

const InfomationDialog = (props) => {
  const { open, setOpen, patientDetails, setPatientDetails, type } = props;
  const classes = useStyle();

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Dialog
      open={open}
      maxWidth={"xs"}
      onClose={handleClose}
      // onClose={(e) => {
      //   if (e.key === "Escape") {
      //     handleClose();
      //   }
      // }}
    >
      <PrimaryDialogTitle handleClose={handleClose} title="Patient Details" />
      <DialogContent>
        {type === "repeatOrder" && (
          <>
            <Grid className={classes.rsPatientDetails}>
              <Typography medium variant="h4">
                Status:&nbsp;
              </Typography>
              <Typography regular variant="h5">
                {patientDetails.status ? patientDetails.status : "N / A"}
              </Typography>
            </Grid>
            <Grid className={classes.rsPatientDetails}>
              <Typography medium variant="h4">
                Dob:&nbsp;
              </Typography>
              <Typography regular variant="h5">
                {patientDetails?.dob
                  ? moment(new Date(patientDetails?.dob)).format(
                      "DD-MM-YYYY"
                    ) || "N / A"
                  : "N / A"}
              </Typography>
            </Grid>
          </>
        )}
        {type === "patient" && (
          <>
            {/* <Grid className={classes.rsPatientDetails}>
              <Typography medium variant="h4">
                Patient Type:&nbsp;
              </Typography>
              <Typography regular variant="h5">
                {patientDetails?.type
                  ? patientDetails?.type === "collection"
                    ? "Collection"
                    : "Delivery"
                  : "N / A"}
              </Typography>
            </Grid>
            <Grid className={classes.rsPatientDetails}>
              <Typography medium variant="h4">
                Dispense Type:&nbsp;
              </Typography>
              <Typography regular variant="h5">
                {patientDetails?.instalment_type
                  ? InstallmentDispensingDetail[patientDetails?.instalment_type]
                      .label
                  : "N / A"}
              </Typography>
            </Grid> */}
            <Grid className={classes.rsPatientDetails}>
              <Typography medium variant="h4">
                Group:&nbsp;
              </Typography>
              <Typography regular variant="h5">
                {patientDetails?.g_name ? patientDetails?.g_name : "N / A"}
              </Typography>
            </Grid>
          </>
        )}
        {type === "collection" && (
          <>
            <Grid className={classes.rsPatientDetails}>
              <Typography medium variant="h4">
                Pharmacy:&nbsp;
              </Typography>
              <Typography regular variant="h5">
                {patientDetails?.pharmacy_name
                  ? capitalizeFirstLetter(patientDetails?.pharmacy_name)
                  : "N / A"}
              </Typography>
            </Grid>
            <Grid className={classes.rsPatientDetails}>
              <Typography medium variant="h4">
                Surgery:&nbsp;
              </Typography>
              <Typography regular variant="h5">
                {patientDetails?.surgery_name
                  ? patientDetails?.surgery_name
                  : "N / A"}
              </Typography>
            </Grid>
            <Grid className={classes.rsPatientDetails}>
              <Typography medium variant="h4">
                Order On:&nbsp;
              </Typography>
              <Typography regular variant="h5">
                {moment(new Date(patientDetails?.created_at)).format(
                  "DD-MM-YYYY"
                ) || "N / A"}
              </Typography>
            </Grid>
          </>
        )}
        <Grid className={classes.rsPatientDetails}>
          <Typography medium variant="h4">
            Address:&nbsp;
          </Typography>
          <Typography regular variant="h5">
            {patientDetails.address ? patientDetails.address : "N / A"}
          </Typography>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          children="Close"
          variant="outlined"
          onClick={() => handleClose()}
        />
      </DialogActions>
    </Dialog>
  );
};
export default InfomationDialog;
